/**
 * Subscription plans constants
 * Contains only essential data that might be returned by the backend API
 */

export const SUBSCRIPTION_PLAN_TYPES = {
  FREE: "FREE",
  PREMIUM: "PREMIUM",
  PLATINUM: "PLATINUM",
};

// Currency symbol for subscription plans
export const SUBSCRIPTION_CURRENCY = "RM";

export const SUBSCRIPTION_PLANS = [
  {
    id: SUBSCRIPTION_PLAN_TYPES.FREE,
    name: "Free",
    price: "0",
    currency: SUBSCRIPTION_CURRENCY,
    period: "/ user",
    description: "Parts of the features available",
    features: [
      { text: "General Standard Features", available: true },
      { text: "Leave and Task Management", available: true },
      { text: "Company Calendar", available: true },
      { text: "Clock In & Out", available: false },
    ],
  },
  {
    id: SUBSCRIPTION_PLAN_TYPES.PLATINUM,
    name: "Platinum",
    price: "10",
    currency: SUBSCRIPTION_CURRENCY,
    period: "/month per user",
    description: "All features available",
    tag: "Most Popular",
    features: [
      { text: "Everything in Premium Plan", available: true },
      { text: "Create custom Claim & Limit", available: true },
      { text: "Expenses Claim Management", available: true },
      { text: "Asset Management", available: true },
      { text: "Create announcement", available: true },
    ],
  },
  {
    id: SUBSCRIPTION_PLAN_TYPES.PREMIUM,
    name: "Premium",
    price: "5",
    currency: SUBSCRIPTION_CURRENCY,
    period: "/month per user",
    description: "Useful features available",
    features: [
      { text: "Everything in Free Plan", available: true },
      { text: "Attendance Report", available: true },
      { text: "Clock In & Out", available: true },
      { text: "Expenses Claim Management", available: false },
    ],
  },
];

/**
 * UI-specific constants for subscription plans
 * These would not be returned by the backend
 */
export const SUBSCRIPTION_PLAN_UI = {
  [SUBSCRIPTION_PLAN_TYPES.FREE]: {
    headerClass: "free",
    isHighlight: false,
  },
  [SUBSCRIPTION_PLAN_TYPES.PREMIUM]: {
    headerClass: "premium",
    isHighlight: false,
  },
  [SUBSCRIPTION_PLAN_TYPES.PLATINUM]: {
    headerClass: "platinum",
    isHighlight: true,
  },
};

/**
 * Get the UI-specific properties for a subscription plan
 * @param {string} planId - The plan ID
 * @returns {object} UI properties for the plan
 */
export const getSubscriptionPlanUI = (planId) => {
  return (
    SUBSCRIPTION_PLAN_UI[planId] ||
    SUBSCRIPTION_PLAN_UI[SUBSCRIPTION_PLAN_TYPES.FREE]
  );
};

/**
 * Find a subscription plan by ID
 * @param {string} planId - The plan ID to find
 * @returns {object|null} The plan object or null if not found
 */
export const findSubscriptionPlanById = (planId) => {
  return SUBSCRIPTION_PLANS.find((plan) => plan.id === planId) || null;
};
